import { useUser as useClerkUser, useSession } from "@clerk/nextjs";

interface UseUserReturn {
  user: ReturnType<typeof useClerkUser>["user"];
  session: ReturnType<typeof useSession>["session"];
  isLoaded: boolean;
  isSuperUser: boolean;
  isAgencyUser: boolean;
  isDealManager: boolean;
}

export function useUser(): UseUserReturn {
  const { user, isLoaded } = useClerkUser();
  const { session, isLoaded: isSessionLoaded } = useSession();

  // check if user is superuser
  const isSuperUser = Boolean(user?.publicMetadata?.isSuperUser);
  const isDealManager = Boolean(user?.publicMetadata?.isDealManager);
  const isAgencyUser = Boolean(user?.publicMetadata?.isAgencyUser);

  return {
    user,
    session,
    isLoaded: isLoaded && isSessionLoaded,
    isSuperUser,
    isAgencyUser,
    isDealManager,
  };
}
